module.exports = __webpack_public_path__ + "img/2.20d31685.jpg";